import type { AddNoteRequest } from '@contracts/note/AddNoteRequest';
import { PermitApplicationClient } from '@src/permits/services/PermitApplicationClient';
import { useMutation } from '@tanstack/react-query';

interface Props {
  permitApplicationId: string;
  onSuccess: () => void;
  onError: () => void;
}

export const useReplacePermitType = ({
  permitApplicationId,
  onSuccess,
  onError,
}: Props) => {
  const { mutate, isPending } = useMutation({
    mutationFn: ({
      newPermitTypeOriginalId,
      note,
    }: {
      newPermitTypeOriginalId: string;
      note?: AddNoteRequest;
    }) =>
      PermitApplicationClient.replacePermitType({
        permitApplicationId,
        newPermitTypeOriginalId,
        note,
      }),
    onSuccess,
    onError,
  });

  return {
    replacePermitType: mutate,
    isPending,
  };
};
